import { useEffect, useState, Fragment, forwardRef } from 'react';
import { styled } from '@mui/system';
import { IconButton, Dialog,DialogTitle,DialogContent,DialogActions, Slide } from '@mui/material';
import Icon from 'app/components/Icon';

const DialogBox = styled(Dialog)(({ padding, hs = 19 }) => ({
    '& .MuiDialogContent-root':{ padding: padding==="null" ? 20 : `${padding}px` }, 
    '& .MuiDialogActions-root': { padding:`8px ${padding || 8}px` },
    '& .modal-title': { fontSize:`${hs}px`, '& .fa': { fontSize:`${hs-1}px` } }
}));

export default function Modal({ title = null, titleIcon = null, body, open=false, onClose, children, maxWidth="xs", disableEscapeKey=true, keepMounted=true, variant="outlined", fullWidth = true, transition, stopTransition = false, scroll="paper", footer, disableBackdrop = false, closeButton = true, padding = null, headerSize = 19, style = null }) {

    const [isOpen,setOpen] = useState(false);
    
    const handleOpen = (val, e, reason) => {
        if( disableBackdrop && reason && reason === "backdropClick") return;
        if( val === isOpen )return false;
        setOpen(val);
        setTimeout(()=>{
            if( document.getElementsByClassName('MuiDialog-root').length > 0 ){
                for(var i= 0; i < document.getElementsByClassName('MuiDialog-root').length; i++){
                    document.getElementsByClassName('MuiDialog-root')[i].style.setProperty("display", val ? "block" : "none");
                }
            }
        },1);
        if( !val && onClose && isOpen ) onClose();
    }

    useEffect(()=>{    
        handleOpen(open);
    },[open]);

    const Transition = forwardRef(function Transition(props, ref) {
      return <Slide direction="up" ref={ref} {...props} />;
    });

    if( !(body || children) ) return null;

    const renderIcon = (cls = '') =>{
        return <IconButton className={`modal-close ${cls}`} onClick={()=>handleOpen(false)}><Icon>times</Icon></IconButton>
    }
    const dprops =  {};
    if( !stopTransition )
        dprops.TransitionComponent = transition || Transition;

    return <DialogBox 
            className={`dialog_box ${closeButton ? 'cb' : ''}`}
            open={isOpen} 
            fullWidth={fullWidth} 
            maxWidth={maxWidth} 
            disableEscapeKeyDown={disableEscapeKey} 
            keepMounted={keepMounted} 
            variant={variant} 
            scroll={scroll} 
            onClose={(e,r)=>handleOpen(false,e,r)} 
            ht={title ? 1 : 0} 
            padding={padding === null ? "none" : parseInt(padding)} 
            hs={headerSize}
            {...dprops}
            sx={style}
        >  
        {closeButton && renderIcon('nt')}
        {body ? body : <Fragment>
            {title && <DialogTitle className="modal-title">
                {titleIcon && <Icon>{titleIcon}</Icon>}
                <span className="main">{title}</span>
            </DialogTitle>}            
            <DialogContent id="modalDialogContent">
                {children}
            </DialogContent>
        </Fragment>}
        {footer && <DialogActions>{footer}</DialogActions>}
    </DialogBox>
}